// extracted by mini-css-extract-plugin
module.exports = {"root":"with-link-auth_root__3z8Hc"};